import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'lib/actions';
import More from '../presentational/More';
import { getTheme } from 'selectors/darkMode';
import { showModal } from 'actions/modal';
import { EXPORT_STATEMENT_MODAL } from 'constants/shared/modalTypes';

const MoreContainer: FC = () => {
    const dispatch = useDispatch();
    const isDarkModeEnabled = useSelector(getTheme);

    const handleShowExportModal = () => {
        dispatch(showModal({ type: EXPORT_STATEMENT_MODAL, props: {} }));
    };

    const handleLogoutClick = () => {
        dispatch(logout());
    };

    return (
        <More
            logoutClick={handleLogoutClick}
            isDarkModeEnabled={isDarkModeEnabled as boolean}
            handleShowExportModal={handleShowExportModal}
        />
    );
};

export default MoreContainer;
